import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import useLink from "@qpr/client-api-base/hooks/useLink";
import useElement from "backend/hooks/elements/useElement";
import useFlatHierarchy from "backend/hooks/elements/useFlatHierarchy";
import ToolbarWithHeading from "components/toolbars/ToolbarWithHeading";
import {
  InitiativesHeader,
  KpisHeader,
  MeasurementHeader,
} from "design/components/texts/Headers";
import { KPICard } from "design/components/cards/KPICard";
import KPIGridArea from "design/components/grids/MeasureGridArea";
import SplitView from "design/layouts/SplitView";
import Page from "design/pages/Page";
import React from "react";
import PageContainer from "design/layouts/PageContainer";
import StrategyToolbar from "components/toolbars/StrategyToolbar";
import Center from "design/layouts/Center";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import { InitiativeCard } from "design/components/cards/InitiativeCard";
import { t } from "i18next";

const Initiatives = () => {
  const ctx = useAppContext();
  const { data: root } = useScorecardTopElement("L0");

  const link = useLink();
  const { data, isLoading, isPreviousData, isRefetching } = useFlatHierarchy(
    ctx.elementId || root?.id
  );
  const { data: element, isLoading: isElementLoading } = useElement(
    ctx.elementId || root?.id
  );

  return (
    <Page
      isLoading={
        isLoading || isPreviousData || isRefetching || isElementLoading
      }
      Toolbar={StrategyToolbar}
    >
      <PageContainer width="1350px">
        <KPIGridArea>
          <InitiativesHeader header={t("initiatives.Initiatives")} />
          {data
            ? data
                .filter((el) => el.typename === "Initiative")
                .map((el) => (
                  <InitiativeCard
                    left_number_key="PLANNED_COMPLETION_prettyvalue"
                    left_number_title="Planned Progress"
                    right_number_key="VARIANCE_prettyvalue"
                    right_number_title="Variance"
                    cardTitle={t("initiatives.Actual Progress")}
                    period={ctx.period || ""}
                    key={`${el.id}-${ctx.period}`}
                    element={el}
                    onSelect={() => {
                      link({ page: "initiativedetails", meaId: el.id });
                    }}
                  />
                ))
            : null}
        </KPIGridArea>
      </PageContainer>
    </Page>
  );
};

export default Initiatives;
